import React from "react";
import OrderListCommonLayer from "./OrderListCommonLayer";

const DispatchedOrdersLayer = () => {
    return (
        <OrderListCommonLayer
            pageTitle="Dispatched Orders"
            categoryStatus="Dispatched"
            categoryPayStatus=""
        />
    );
};

export default DispatchedOrdersLayer;
